import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'containsSubstrOf',
})
// eslint-disable-next-line @angular-eslint/use-pipe-transform-interface
export class ContainsSubstrOf {
  transform(value: string, stringArray: string[]): boolean {
    return stringArray.some((str) => value.includes(str));
  }
}
